import React,{useEffect, useState} from 'react'
import CollapseSection from '../../components/ui/CollapseSection'
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {sizes} from './fileTransferUtils';
import CustomLoadingScreen from '../../components/ui/CustomLoadingScreen';
//import SharedComponent from './SharedComponent';
import { useDispatch, useSelector } from "react-redux";
import {GetUserCountries,clearStatus,setState,GetQuotaFileStatus,getScenariosData,GetQuotaFileGenerateStatus} from './fileTransferSlice';
import CustomButton from '../../components/ui/CustomButton';
import MessageSnackbar from "../../components/ui/MessageSnackbar";
import MultiSelectScenario from './MultiSelectScenario';

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

const fileTypes = [
	{ key: 1, value: "Quota" },
	{ key: 2, value: "Quota Modification" },
];

const QuotaFileGenerate = () => {
  
  const dispatch = useDispatch();
  const fileTransfer = useSelector((state) => state.fileTransfer);
  const {
    countries,
    isLoading,
    selectedCountry,
    selectedCountryID,
    quotaFileDate,
    qMStartDate,
    qMEndDate,
    isSuccess,
    isSuccess_Info,
    isAlert,
    isAlert_Info,
    scenariosData,
    selectedScenarioIds
  } = fileTransfer;

  const [selectedFileType,setSelectedFileType]=useState("");
  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });
  const minDate = dayjs().add(-1, 'month').startOf('month');;
  const maxDate = dayjs().add(3, 'month').endOf('month');
  const minQMDate = dayjs().startOf('month');
  const maxQMDate = dayjs().endOf('month');
  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  const handleCloseSnackbar=()=>{
    clearAlert();
  }
  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  useEffect(() => {
    return () => {
      // Clear alert and success messages on unmount
      dispatch(setState("isSuccess", false));
      dispatch(setState("isSuccess_Info", ""));
      dispatch(setState("isAlert", false));
      dispatch(setState("isAlert_Info", ""));
    };
  }, []);

  useEffect(()=>{
    dispatch(setState("selectedCountry",""));
    dispatch(setState("selectedCountryID",""));
    dispatch(setState("selectedScenarioIds", []));
    dispatch(setState("scenariosData", []));
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  },[]);

  useEffect(() => {
    if (selectedCountry !== "") {
        debugger;
        getScenariosForCountry();
    }
}, [selectedCountry]);  

  function getScenariosForCountry() {
    const countryID = selectedCountryID;
    dispatch(getScenariosData(countryID));
}



  const setCountry=(event)=> {
      const name = event.target.value;
      let id = countries?.find((country) => country.countryName === name).countryID;
      dispatch(setState("selectedCountry", name));
      dispatch(setState("selectedCountryID", id));
    }

    const updateQuotaFileDate = (newDate) => {
     dispatch(setState("quotaFileDate",newDate));
    }
    const updateQuotaModificationStartDate = (newQMStartDate) => {
      dispatch(setState("qMStartDate",newQMStartDate));
     }
    const updateQuotaModificationEndDate = (newQMEndDate) => {
      dispatch(setState("qMEndDate",newQMEndDate));
     }

    // const disableDates = (date) => {
    //   const currentDate = dayjs();
    //   const firstDayOfMonth = date.date() === 1;
    //   const isMonday = date.day() === 1;
    //   const isToday = date.isSame(currentDate, 'day');
    //   const isBiWeekly = date.date()===16;
  
    //   return !(firstDayOfMonth || isMonday || isToday || isBiWeekly);
    // };

    const generateQuotaFile=()=>{
        debugger;
      if(selectedCountry=== ""){
        displayAlert(true,"Please select a country");
        return;
      }
      let generationDate = "";
      let endDate = "";

      if(selectedScenarioIds.length <= 0){
        displayAlert(true,"Please select atleast one scenario");
        return;
      }

      // If the file type is "Quota", check and validate the quotaFileDate
    //   if(selectedFileType==="Quota"){
        if (!dayjs(quotaFileDate).isValid()) {
          displayAlert(true,"Please select a date");
          return;
        }
        const genDt = new Date(dayjs(quotaFileDate).startOf("day").toDate());
        const currentDate = new Date();
        const minDate = new Date(dayjs().add(-1, "months").startOf("month").toDate());
        const maxDate = new Date(dayjs().add(3, "months").endOf("month").toDate());
        
        if(genDt< minDate || genDt>maxDate){
          displayAlert(true, "This date is not allowed");
          return;          
        }

        generationDate = dayjs(genDt).format("YYYY-MM-DD"); // Set the valid generation date

       // request object
       console.log("Selected Scenario IDs:", selectedScenarioIds);
      const requestData = {
        countryID: selectedCountryID,
        scenarioIds: selectedScenarioIds,
        generationDate: generationDate,
        requestedUser: JSON.parse(localStorage.getItem("data"))?.email || "",
      };

      dispatch(GetQuotaFileGenerateStatus(requestData));
    }
    const alertDuration=10000;
    const successDuration=10000;

    function queuePopMsgOnClose() {
      dispatch(setState("isAlert", false));
      dispatch(setState("isAlert_Info", ""));
    }
    function successPopMsgOnClose() {
      dispatch(setState("isSuccess", false));
      dispatch(setState("isSuccess_Info", ""));
    }

  return (
   <Box mt={3}>
      <CollapseSection title="Quota File Generation">
        <Box mt={3}>
         {/* Display success message */}
          {fileTransfer.isSuccess && (
            <MessageSnackbar
              message={fileTransfer.isSuccess_Info}
              severity="success"
              open={fileTransfer.isSuccess}
              onClose={successPopMsgOnClose}
              autoHideDuration={successDuration}
              sx={{
                position:"fixed",
                top:20,
                left:"50%",
                transform:"translateX(-50%)",
                width:"300px"
              }}
            />
          )}
      {/* Display info message */}
          {fileTransfer.isAlert && (
            <MessageSnackbar
              message={fileTransfer.isAlert_Info}
              severity="info"
              open={fileTransfer.isAlert}
              onClose={queuePopMsgOnClose}
              autoHideDuration= {alertDuration}
              sx={{
                position:"fixed",
                top:100,
                left:"50%",
                transform:"translateX(-50%)",
                width:"300px"
              }}
            />
          )}
         {/* Display alert message */}
        {alert.alertDisplay && (
            <MessageSnackbar
            message={alert.alertMessage}
            severity={alert.alertSeverity}
            open={alert.alertDisplay}
            onClose={handleCloseSnackbar}
          />
        )}
          <CustomLoadingScreen isLoading={isLoading} />
          {/* <SharedComponent /> */}
          <Grid container columns={12} columnGap={2} rowGap={2}>
            <Grid item sm={2}>
              <FormControl>
                <InputLabel>Country</InputLabel>
                <Select
                  value={selectedCountry}
                  label="Country"
                  sx={{
                    height: selectHeight,
                    width: selectWidth,
                    color: "black.main",
                    mt: 1,
                  }}
                  onChange={setCountry}
                >
                  {countries.map((country, index) => {
                    return (
                      <MenuItem key={index} value={country.countryName}>
                        {country.countryName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid
					item
				>
					<MultiSelectScenario scenariosData={scenariosData} />
				</Grid>            

            <Grid item sm={2}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={minDate}
                    maxDate={maxDate}
                    label="Quota File Date"
                    value={quotaFileDate || null}
                    //shouldDisableDate={disableDates}
                    onChange={(newValue) => updateQuotaFileDate(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ width: sizes.w300 }}
                      />
                    )}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Box>
			</Grid>
            


            <Grid item sm={2}>
              <CustomButton onClick={generateQuotaFile} size="large">Generate Quota File</CustomButton>
            </Grid>
          </Grid>
        </Box>
      </CollapseSection>
   </Box>
  )
}

export default QuotaFileGenerate